
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/archive/[page]",
      function () {
        return require("private-next-pages/archive/[page]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/archive/[page]"])
      });
    }
  